export default __webpack_public_path__ + "static/SRI 4400 - Product Specifications & Technical Data-d414437a47b4f29207f029b20f2fa2e4.pdf";